/*
 * @Author: dinglizu
 * @Date: 2022-04-22 20:34:54
 * @LastEditTime: 2022-10-06 11:42:16
 * @LastEditors: dinglizu
 * @Description: 
 */
export const token = state => state.token
export const aliyunDeviceCode = state => state.aliyunDeviceCode
export const userInfo = state => state.userInfo
export const toeflModel = state => state.toeflModel
export const dictationModel = state => state.dictationModel
export const testReport = state => state.testReport
export const browse = state => state.browse
export const orgInfo = state => state.orgInfo
export const practice = state => {
    let _practice = state.practice;
    return _practice
}
export const card = state => {
    let _card = state.card;
    return _card
}
export const routeName = state => state.routeName
export const globalConfig = state => {
    let _globalConfig = state.globalConfig;
    return _globalConfig
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js